var alignmentStyle = {"alignLeft":"-C1J3","textWrapNowrap":"iqpzL","alignRight":"VVdkI","alignCenter":"IHTss","sizeFullWidth":"qUw65","renderedInTable":"qunOB","sizeOriginal":"h5HG1","sizeContent":"rk3Kk","sizeSmall":"_1Gx84","sizeSmallCenter":"_0TRMV","flex":"_0gHKd","LEFT":"bhrij","CENTER":"CvbfW","RIGHT":"_8OSoH","AUTO":"ue8fA","JUSTIFY":"oec3b"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-9056c304.js.map
